module.exports = __webpack_public_path__ + "assets/img/03.66e6cd25.png";